import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components/macro'
import { useHistory } from 'react-router-dom'
import { MEDIA, COLORS, FONT_FAMILIES, withFullWidth } from '../../utils/styles'
import { ReactComponent as BlobLeft } from '../../statics/images/babyname/blob-left.svg'
import { ReactComponent as BlobRight } from '../../statics/images/babyname/blob-right.svg'
import { ReactComponent as SearchIcon } from '../../statics/images/babyname/icon-magnify.svg'
import { ReactComponent as NavLeftIcon } from '../../statics/images/icon-nav-left.svg'
import { ReactComponent as LogoMomcom } from '../../statics/images/logo-momcom.svg'
import Link from 'wsc/components/Link'
import { ALPHABET, searchURL } from '../../configs/babyname'
import { sendGaEvent } from 'wsc/utils/googleTagManager'

const ScFlexWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${COLORS.DUCK_EGG_BLUE};
  overflow: hidden;

  ${MEDIA.MOBILE_S`
    ${withFullWidth}
  `}
`
const ScHeaderWrapper = styled.div`
  z-index: 1;
  text-align: center;
  margin-top: 24px;
`
const ScLogoMomcom = styled(LogoMomcom)`
  height: 32px;
`
const ScHeaderTitle = styled.p`
  margin-top: 8px;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 1.25rem;
  line-height: 1.7;
  ${MEDIA.TABLET`
    font-size: 1.18rem
    line-height: 1.68;
  `}
  ${MEDIA.MOBILE`
    font-size: 1.12rem
    line-height: 1.72;
  `}
`
const ScHeaderDescription = styled.p`
  margin-top: 4px;
  font-size: 1rem;
  line-height: 1.69;
  margin: 0 24px;
  ${MEDIA.DESKTOP`
    font-size: 0.93rem;
    line-height: 1.73;
    margin: 0 96px;
  `}
  ${MEDIA.TABLET`
    margin: 0 80px;
  `}
`
const ScBlobLeft = styled(BlobLeft)`
  position: absolute;
  top: -1px;
  left: -1px;
  width: 130px;
`
const ScBlobRight = styled(BlobRight)`
  position: absolute;
  height: auto;
  width: 240px;
  top: 25px;
  right: -1px;
  ${MEDIA.MOBILE`
    top: 45px;
    right: -30px;
  `}
`
const ScSearchBoxWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 10px 0 rgba(20, 106, 97, 0.1);
  background-color: ${COLORS.BACKGROUND_GREY};
  margin-top: 36px;
  margin-bottom: 24px;
  ${MEDIA.DESKTOP`
    margin-top: 35px;
    width: 488px;
  `}
  ${MEDIA.TABLET`
    width: 448px;
  `}
  ${MEDIA.MOBILE`
    width: 344px;
  `}
  z-index: 1;
`
const ScSearchByWrapper = styled.div`
  position: absolute;
  top: -12px;
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 2;
`
const ScSearchByItem = styled.div`
  border-radius: 50px;
  margin: 0 8px;
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  background-color: ${COLORS.BORDER_GREY};
  color: ${COLORS.LETTER_GREY};
  padding: 0 16px;
  font-size: 0.75rem;
  line-height: 24px;
  letter-spacing: 0.72px;
  height: 24px;
  ${MEDIA.DESKTOP`
    font-size: 0.68rem;
    line-height: 23px;
    letter-spacing: 0.66px;
    height: 23px;
    &:hover {
      background-color: ${COLORS.DARK_GREEN};
      color: ${COLORS.WHITE};
    }
  `}
  ${MEDIA.MOBILE`
    margin: 0 6px;
  `}

  ${props =>
    props.isActive &&
    `
      background-color: ${COLORS.GREYISH_TEAL};
      color: ${COLORS.WHITE};
      font-weight: bold;
  `}
`
const ScSearchInputWrapper = styled.div`
  position: relative;
  height: 34px;
  margin: 36px 32px 24px;
`
const ScInput = styled.input`
  background-color: transparent;
  color: ${COLORS.BLACK};
  width: 100%;
  font-family: ${FONT_FAMILIES.SANSSERIF};
  border: none;
  border-bottom: solid 1px ${COLORS.BORDER_GREY_2};
  &:focus {
    outline: none;
  }
  font-weight: 600;
  font-size: 1.25rem;
  line-height: 1.7;
  ${MEDIA.TABLET`
    font-size: 1.18rem
    line-height: 1.68;
  `}
  ${MEDIA.MOBILE`
    font-size: 1.12rem
    line-height: 1.72;
  `}
`
const ScSearchIcon = styled(SearchIcon)`
  height: 16px;
  width: 16px;
  fill: ${COLORS.GREY};
  margin-right: 8px;
  ${MEDIA.DESKTOP`
    margin-right: 4px;
  `}
`
const ScPlaceHolder = styled.span`
  color: ${COLORS.GREY};
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;

  ${ScInput}:not([value='']) + & {
    display: none;
  }
`
const ScLetterSelect = styled.select`
  background-color: transparent;
  color: ${COLORS.BLACK};
  width: 100%;
  font-family: ${FONT_FAMILIES.SANSSERIF};
  border: none;
  border-bottom: solid 1px ${COLORS.BORDER_GREY_2};
  &:focus {
    outline: none;
  }
  font-weight: 600;
  font-size: 1.25rem;
  line-height: 1.7;
  ${MEDIA.TABLET`
    font-size: 1.18rem
    line-height: 1.68;
  `}
  ${MEDIA.MOBILE`
    font-size: 1.12rem
    line-height: 1.72;
  `}
  ${props =>
    props.isPlaceHolder &&
    `
      font-weight: normal;
      color: ${COLORS.GREY};
  `}
`
const ScOptionTitle = styled.span`
  text-transform: uppercase;
  font-weight: 600;
  text-align: center;
  font-size: 0.75rem;
  line-height: 1.67;
  letter-spacing: 0.72px;
  ${MEDIA.DESKTOP`
    font-size: 0.68rem;
    line-height: 1.73;
    letter-spacing: 0.66px;
  `}
`
const ScOptionWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 4px;
  margin-bottom: 24px;
`
const ScOptionItem = styled.div`
  border-radius: 50px;
  margin: 0 4px;
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  background-color: ${COLORS.WHITE};
  border: solid 1px ${COLORS.BORDER_GREY_2};
  color: ${COLORS.GREY};
  padding: 0 16px;
  font-size: 1rem;
  line-height: 38px;
  height: 38px;

  ${MEDIA.DESKTOP` 
    &:hover {
      border: solid 1px  ${props => (props.isActive ? props.hoverColor : props.activeColor)} ;
    }
    font-size: 0.93rem;
    line-height: 36px;
    height: 36px;
  `}

  ${props =>
    props.isActive &&
    `
      font-weight: 600;
      background-color: ${props.activeColor};
      border: solid 1px ${props.activeColor};
      color: ${COLORS.BLACK};
  `}
`
const ScNavLeftIcon = styled(NavLeftIcon)`
  height: 8px;
  width: 4.6px;
  margin-left: 14px;
`
const ScSearchButton = styled(({ isActive, tabindex, ...restProps }) => <Link {...restProps} />)`
  display: flex;
  align-items: center;
  height: 36px;
  padding: 8px 24px;
  margin-bottom: 24px;
  font-size: 0.93rem;
  font-weight: bold;
  cursor: default;
  border: solid 1px ${COLORS.WHITE};
  color: ${COLORS.WHITE};
  z-index: 1;
  svg {
    fill: ${COLORS.WHITE};
  }
  pointer-events: none;

  ${props =>
    props.isActive &&
    `
    cursor: pointer;
    background-color: ${COLORS.WHITE};
    border: solid 1px ${COLORS.GREYISH_TEAL};
    color: ${COLORS.GREYISH_TEAL};
    svg {
      fill: ${COLORS.GREYISH_TEAL};
    }
    pointer-events: auto;
  `}
`

const SELECT_OPTIONS = ALPHABET.map(option => {
  return (
    <option value={option} key={`option-${option}`}>
      {option}
    </option>
  )
})

const Header = () => {
  return (
    <ScHeaderWrapper>
      <ScLogoMomcom />
      <ScHeaderTitle>Baby names finder</ScHeaderTitle>
      <ScHeaderDescription>
        Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod
      </ScHeaderDescription>
    </ScHeaderWrapper>
  )
}

const sendGaEventOnSearch = (isSearchByName, isModal) => {
  const action = isModal
    ? isSearchByName
      ? 'Name Search Float Button'
      : 'Browse by Letter Float Button'
    : isSearchByName
    ? 'Name Search Static Button'
    : 'Browse by Letter Static Button'
  sendGaEvent({
    category: 'Baby Name Search',
    action: action,
    label: window.location.pathname + window.location.search,
  })
}

const SearchWidget = ({ withHeader, autoFocus, isModal, closeModalFunc }) => {
  const [isSearchByName, setIsSearchByName] = useState(true)
  const [name, setName] = useState('')
  const [letter, setLetter] = useState('')
  const [isBoy, setIsBoy] = useState(false)
  const [isGirl, setIsGirl] = useState(false)
  const [isNeutral, setIsNeutral] = useState(false)
  const history = useHistory()
  const searchInputRef = useRef(null)
  const searchKeyword = name.trim()
  const isSearchButtonActive =
    (isSearchByName && searchKeyword !== '') || (!isSearchByName && letter !== '')

  useEffect(() => {
    isSearchByName && autoFocus && searchInputRef && searchInputRef.current.focus()
  }, [isSearchByName, autoFocus])

  const clearState = () => {
    setName('')
    setLetter('')
    setIsBoy(false)
    setIsGirl(false)
    setIsNeutral(false)
  }

  return (
    <ScFlexWrapper>
      {withHeader && <Header />}
      <ScSearchBoxWrapper>
        <ScSearchByWrapper>
          <ScSearchByItem isActive={isSearchByName} onClick={() => setIsSearchByName(true)}>
            SEARCH BY NAME
          </ScSearchByItem>
          <ScSearchByItem isActive={!isSearchByName} onClick={() => setIsSearchByName(false)}>
            BROWSE BY LETTER
          </ScSearchByItem>
        </ScSearchByWrapper>
        {isSearchByName ? (
          <ScSearchInputWrapper>
            <ScInput
              ref={searchInputRef}
              id="search-bar"
              type="text"
              value={name}
              onChange={event => setName(event.target.value)}
              onKeyDown={event => {
                // allow user to hit 'Enter' on keyboard to start a search
                if (event.key === 'Enter' && searchKeyword !== '') {
                  sendGaEventOnSearch(isSearchByName, isModal)
                  history.push(searchURL(searchKeyword, isBoy, isGirl, isNeutral))
                  closeModalFunc()
                  clearState()
                }
                // prevent user to type '%' to avoid URI malformed when decode
                else if (event.key === '%') {
                  event.preventDefault()
                }
              }}
            />
            <ScPlaceHolder>
              <ScSearchIcon />
              Search “Jordan” or “Jor”
            </ScPlaceHolder>
          </ScSearchInputWrapper>
        ) : (
          <ScSearchInputWrapper>
            <ScLetterSelect
              onChange={event => setLetter(event.target.value)}
              value={letter}
              isPlaceHolder={letter === ''}
            >
              <option value="">Name starts with the letter</option>
              {SELECT_OPTIONS}
            </ScLetterSelect>
          </ScSearchInputWrapper>
        )}
        <ScOptionTitle>Select Gender (Optional)</ScOptionTitle>
        <ScOptionWrapper>
          <ScOptionItem
            onClick={() => setIsNeutral(!isNeutral)}
            isActive={isNeutral}
            activeColor={COLORS.LIGHT_PALE_ORANGE}
            hoverColor={COLORS.PALE_ORANGE}
          >
            Neutral
          </ScOptionItem>
          <ScOptionItem
            onClick={() => setIsBoy(!isBoy)}
            isActive={isBoy}
            activeColor={COLORS.VERY_LIGHT_BLUE}
            hoverColor={COLORS.PASTEL_BLUE}
          >
            Boys
          </ScOptionItem>
          <ScOptionItem
            onClick={() => setIsGirl(!isGirl)}
            isActive={isGirl}
            activeColor={COLORS.PALE_MAUVE}
            hoverColor={COLORS.POWDER_PINK}
          >
            Girls
          </ScOptionItem>
        </ScOptionWrapper>
      </ScSearchBoxWrapper>
      <ScSearchButton
        to={searchURL(
          isSearchByName ? searchKeyword : letter,
          isBoy,
          isGirl,
          isNeutral,
          isSearchByName
        )}
        withDefaultStyle={false}
        isActive={isSearchButtonActive}
        // disable navigate by Tab to reach this button when searchButton is not active
        tabindex={isSearchButtonActive ? 0 : -1}
        onClick={() => {
          sendGaEventOnSearch(isSearchByName, isModal)
          closeModalFunc()
          clearState()
        }}
      >
        SEARCH
        <ScNavLeftIcon />
      </ScSearchButton>
      <ScBlobLeft />
      <ScBlobRight />
    </ScFlexWrapper>
  )
}

SearchWidget.propTypes = {
  withHeader: PropTypes.bool,
  autoFocus: PropTypes.bool,
  isModal: PropTypes.bool,
  closeModalFunc: PropTypes.func,
}

SearchWidget.defaultProps = {
  withHeader: false,
  autoFocus: false,
  isModal: false,
  closeModalFunc: () => {},
}

export default SearchWidget
